import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'resetPasswordForm.title',
    defaultMessage: 'Change password',
  },
  description: {
    id: 'resetPasswordForm.description',
    defaultMessage: 'To reset your password, please enter your email address below.',
  },
  emailPlaceholder: {
    id: 'resetPasswordForm.emailPlaceholder',
    defaultMessage: 'Email address',
  },
  submitButton: {
    id: 'resetPasswordForm.submitButton',
    defaultMessage: 'Reset password',
  },
  login: {
    id: 'resetPasswordForm.login',
    defaultMessage: 'Log in',
  },
  signUp: {
    id: 'resetPasswordForm.signUp',
    defaultMessage: 'Sign up',
  },
  fieldRequired: {
    id: 'resetPasswordForm.fieldRequired',
    defaultMessage: 'This field is required',
  },
  incorrectEmailFormat: {
    id: 'resetPasswordForm.incorrectEmailFormat',
    defaultMessage: 'This is not a valid e-mail format',
  },
});
